<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import Qr from './mixins/Qr';
import { constants } from './lib/constants';

export default {
  name: 'App',
  mixins: [Qr],
  data() {
    return {
      interval: null,
    };
  },
  computed: {
    ...mapGetters('application', ['isFetchingFromAPI']),
    ...mapState('order', ['lastOrder']),
    ...mapState('application', ['version', 'language']),
  },
  watch: {
    isFetchingFromAPI(bool) {
      if (bool) {
        this.$q.loading.show({
          spinnerSize: 64,
        });
      }
      else {
        this.$q.loading.hide();
      }
    },
    lastOrder() {
      this.checkDistancingOrder();
    },
    // eslint-disable-next-line func-names
    '$q.appVisible': function (visible) {
      // Checks if app is visible or in background
      if (visible) {
        this.startUpdates();
      }
      else {
        this.stopUpdates();
      }
    },

    language() {
      this.$i18n.locale = this.language;
    },
  },
  async mounted() {
    document.addEventListener('backbutton', this.handleBackButton, true);
    this.startUpdates();
    this.checkDistancingOrder();

    if (this.$q.platform.is.cordova && this.version?.client) {
      // eslint-disable-next-line global-require
      const semverLt = require('semver/functions/lt');
      if (semverLt(process.env.VERSION, this.version.client)) {
        this.$q.dialog({
          title: this.$t('api.error.outDated.title'),
          message: this.$t('api.error.outDated.message'),
        });
      }
    }

    await this.initUser();
    await this.initLocation(constants.DEFAULT_LOCATION);
  },
  methods: {
    ...mapMutations('application', ['setDistancingOrder']),
    ...mapActions('location', ['fetchLocations']),
    handleBackButton() {
      if (this.$route.path === '/login' || this.$route.path === '/menu') {
        navigator.app.exitApp();
      }
      else {
        this.$router.back();
      }
    },
    startUpdates() {
      if (!this.interval) {
        this.fetchLocations(); // Update
        this.interval = setInterval(() => {
          // Keep updating waiting times
          this.fetchLocations();
        }, 600000); // 10 minutes
      }
    },
    stopUpdates() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    checkDistancingOrder() {
      if (this.lastOrder
        && this.lastOrder.distancing === 1
        && (this.lastOrder.status > 1 && this.lastOrder.status < 6)
        && this.lastOrder.deliveryMethodId === 1
        && (this.lastOrder.paymentMethod !== 1
          || (this.lastOrder.paymentMethod === 1 && this.lastOrder.totalPrice === 0)
        )
      ) {
        this.setDistancingOrder(this.lastOrder.id);
      }
    },
  },
};
</script>

<style>
</style>
